// Klipy plugin for Trumbowyg WYSIWYG editor
/* global AbortController: true */
(function ($) {
    'use strict';

    $.extend(true, $.trumbowyg, {
        langs: {
            // jshint camelcase:false
            en: {
                klipy: 'Insert GIF'
            },
            az: {
                klipy: 'GIF yerləşdir'
            },
            by: {
                klipy: 'Уставіць GIF'
            },
            de: {
                klipy: 'GIF einfügen'
            },
            et: {
                klipy: 'Sisesta GIF'
            },
            fr: {
                klipy: 'Insérer un GIF'
            },
            hu: {
                klipy: 'GIF beszúrás'
            },
            ru: {
                klipy: 'Вставить GIF'
            },
            sl: {
                klipy: 'Vstavi GIF'
            },
            tr: {
                klipy: 'GIF ekle'
            }
            // jshint camelcase:true
        }
    });

    var klipyLogo = '<svg viewBox="0 0 100 24" xmlns="http://www.w3.org/2000/svg"><text x="0" y="18" font-family="Arial, sans-serif" font-size="20" font-weight="bold" fill="currentColor">KLIPY</text></svg>'; // jshint ignore:line

    var CANCEL_EVENT = 'tbwcancel';
    var nextCursor = null;

    // Throttle helper
    function trumbowygThrottle(callback, delay) {
        var last;
        var timer;

        return function () {
            var context = this;
            var now = new Date().getTime();
            var args = arguments;

            if (last && now < last + delay) {
                clearTimeout(timer);
                timer = setTimeout(function () {
                    last = now;
                    callback.apply(context, args);
                }, delay);
            } else {
                last = now;
                callback.apply(context, args);
            }
        };
    }

    function registerGifClickEventInModal(trumbowyg, $klipyModal) {
        $klipyModal.on('click', 'img', function () {
            var src = $(this).attr('data-full'),
                alt = $(this).attr('alt');
            trumbowyg.restoreRange();
            trumbowyg.execCmd('insertImage', src, false, true);

            // relay alt tag into inserted image
            if (alt) {
                var $img = $('img[src="' + src + '"]:not([alt])', trumbowyg.$box);
                $img.attr('alt', alt);
                // Note: This seems to fire relatively early and could be wrapped in a setTimeout if needed
                trumbowyg.syncCode();
            }
            $klipyModal.off('click', 'img');
            trumbowyg.closeModal();
        });
    }

    // Fills modal with response gifs
    function renderGifs(response, $klipyModal, trumbowyg, mustEmpty) {
        var $klipyLoading = $klipyModal.siblings('.' + trumbowyg.o.prefix + 'klipy-loading');
        var modalWidth = $klipyModal.width();
        var gapBetweenImages = 10;
        var imagesPerRow = 3;
        var imageWidth = (modalWidth - (gapBetweenImages * (imagesPerRow + 1))) / imagesPerRow;

        nextCursor = response.data.has_next ? response.data.current_page + 1 : null;
        var columnHeights = Array(imagesPerRow).fill(gapBetweenImages);

        if (!mustEmpty) {
            columnHeights = $klipyModal.data('columnHeights') || columnHeights;
        }

        var html = response.data.data
            .map(function (gifData, index) {
                // jshint camelcase:false
                var image = gifData.file.sm.gif,
                    imageRatio = image.height / image.width,
                    altText = gifData.title;

                var full_size = gifData.file.hd.gif.url;

                var imgHtml = '<img src=' + image.url + ' width="' + imageWidth + '" height="' + imageRatio * imageWidth + '" alt="' + altText + '" loading="lazy" data-full="' + full_size + '" />';

                var minHeight = Math.min(...columnHeights);
                var columnIndex = columnHeights.indexOf(minHeight);
                var top = columnHeights[columnIndex];
                var left = gapBetweenImages + (columnIndex * (imageWidth + gapBetweenImages));

                columnHeights[columnIndex] += imageRatio * imageWidth + gapBetweenImages;

                var divHtml = '<div class="img-container" style="position:absolute; top:' + top + 'px; left:' + left + 'px;">' + imgHtml + '</div>';
                return divHtml;
            })
            .join('');

        if (mustEmpty === true) {
            if (html.length === 0) {
                if ($('.' + trumbowyg.o.prefix + 'klipy-no-result', $klipyModal).length > 0) {
                    return;
                }

                html = '<img class="' + trumbowyg.o.prefix + 'klipy-no-result" src="' + trumbowyg.o.plugins.klipy.noResultGifUrl + '"/>';
            }

            $klipyModal.empty();
        }
        $klipyModal.append(html);

        if (!nextCursor) {
            $klipyLoading.hide();
        } else {
            $klipyLoading.show();
        }

        // Remove gray overlay on image load
        // moved here from inline callback definition due to CSP issue
        // Note: this is being done post-factum because load event doesn't bubble up and so can't be delegated
        var addLoadedClass = function (img) {
            img.classList.add('tbw-loaded');
        };
        $('img', $klipyModal).each(function () {
            var img = this;
            if (img.complete) { // images load instantly when cached and esp. when loaded in previous modal open
                addLoadedClass(img);
            } else {
                img.addEventListener('load', function () {
                    addLoadedClass(this);
                });
            }
        });

        $klipyModal.data('columnHeights', columnHeights);

        var maxHeight = Math.max(...columnHeights);
        $klipyModal.css({
            position: 'relative',
            height: maxHeight,
        });
    }

    var defaultOptions = {
        apiKey: null,
        customerId: null,
        locale: 'en_US',
        contentFilter: 'high',
        throttleDelay: 300,
        formats: 'gif',
        perPage: 24,
        noResultGifUrl: 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="200" height="100" viewBox="0 0 200 100"%3E%3Ctext x="50%25" y="50%25" text-anchor="middle" dominant-baseline="middle" font-family="Arial" font-size="16" fill="%23999"%3ENo Results Found%3C/text%3E%3C/svg%3E'
    };

    // Add dropdown with font sizes
    $.extend(true, $.trumbowyg, {
        plugins: {
            klipy: {
                init: function (trumbowyg) {
                    trumbowyg.o.plugins.klipy = $.extend({},
                        defaultOptions,
                        trumbowyg.o.plugins.klipy || {}
                    );

                    trumbowyg.addBtnDef('klipy', {
                        fn: function () {
                            if (trumbowyg.o.plugins.klipy.apiKey === null) {
                                throw new Error('You must set a Klipy API Key');
                            }
                            // Note: Klipy API requires the API key as a path parameter per their official API design
                            // See: https://docs.klipy.com/gifs-api
                            // This is a client-side API key designed for browser usage and should be rate-limited by domain
                            var BASE_URL = 'https://api.klipy.com/api/v1/' + trumbowyg.o.plugins.klipy.apiKey + '/gifs/search?per_page=' + trumbowyg.o.plugins.klipy.perPage +
                                '&customer_id=' + trumbowyg.o.plugins.klipy.customerId +
                                '&locale=' + trumbowyg.o.plugins.klipy.locale +
                                '&content_filter=' + trumbowyg.o.plugins.klipy.contentFilter +
                                '&formats=' + trumbowyg.o.plugins.klipy.formats;

                            var DEFAULT_URL = 'https://api.klipy.com/api/v1/' + trumbowyg.o.plugins.klipy.apiKey + '/gifs/trending?per_page=' + trumbowyg.o.plugins.klipy.perPage +
                                '&customer_id=' + trumbowyg.o.plugins.klipy.customerId +
                                '&locale=' + trumbowyg.o.plugins.klipy.locale +
                                '&content_filter=' + trumbowyg.o.plugins.klipy.contentFilter +
                                '&formats=' + trumbowyg.o.plugins.klipy.formats;

                            var prefix = trumbowyg.o.prefix;
                            var abortController = new AbortController();

                            // Create and open the modal
                            var searchInput = '<input name="" class="' + prefix + 'klipy-search" placeholder="Search a GIF" autofocus="autofocus">',
                                closeButton = '<button class="' + prefix + 'klipy-close" title="' + trumbowyg.lang.close + '"><svg><use xlink:href="' + trumbowyg.svgPath + '#' + prefix + 'close"/></svg></button>',
                                poweredByKlipy = '<div class="' + prefix + 'powered-by-klipy"><span>Powered by</span>' + klipyLogo + '</div>',
                                klipyHeaderHtml = searchInput + closeButton + poweredByKlipy,
                                klipyModalHtml;

                            if ($(trumbowyg.doc.body).hasClass('revamp-page')) {
                                klipyHeaderHtml = '<div class="' + prefix + 'klipy-search-section d-flex gap12 padding20 align-items-center"><div class="' + prefix + 'klipy-search-content flex1 position-relative">' + searchInput + poweredByKlipy + '</div>' + closeButton + '</div>';
                            }
                            klipyModalHtml = klipyHeaderHtml + '<div class="' + prefix + 'klipy-modal-scroll"><div class="' + prefix + 'klipy-modal"></div><p class="' + prefix + 'klipy-loading">Loading more gifs...</p></div>';

                            trumbowyg
                                .openModal(null, klipyModalHtml, false)
                                .one(CANCEL_EVENT, function () {
                                    try {
                                        abortController.abort();
                                        abortController = new AbortController();
                                    } catch (e) {
                                        // AbortController.abort() may throw in older browsers or if already aborted
                                        // This is safe to ignore as we're creating a new controller anyway
                                        if (window.console && console.warn) {
                                            console.warn('Klipy: Could not abort previous search request', e);
                                        }
                                    }

                                    trumbowyg.closeModal();
                                });

                            var $klipyInput = $('.' + prefix + 'klipy-search'),
                                $klipyClose = $('.' + prefix + 'klipy-close'),
                                $klipyModal = $('.' + prefix + 'klipy-modal'),
                                $klipyModalScroll = $('.' + prefix + 'klipy-modal-scroll');

                            var onError = function () {
                                if (navigator.onLine || $('.' + prefix + 'klipy-offline', $klipyModal).length) {
                                    return;
                                }

                                $klipyModal.empty();
                                $klipyModal.append('<p class="' + prefix + 'klipy-offline">You are offline</p>');
                            };

                            registerGifClickEventInModal(trumbowyg, $klipyModal);

                            // Load trending gifs as default
                            fetch(DEFAULT_URL, {
                                method: 'GET',
                                cache: 'no-cache',
                                signal: abortController.signal
                            }).then((response) => {
                                response.json().then((responseJson) => {
                                    renderGifs(responseJson, $klipyModal, trumbowyg, true);
                                });
                            }).catch(function(error) {
                                onError(error);
                            });

                            var searchGifsOnInput = function () {
                                var query = $klipyInput.val();

                                if (query.length === 0) {
                                    return;
                                }

                                try {
                                    abortController.abort();
                                    abortController = new AbortController();
                                } catch (e) {
                                    
                                }

                                $klipyModalScroll.scrollTop(0);
                                fetch(BASE_URL + '&q=' + encodeURIComponent(query), {
                                    method: 'GET',
                                    cache: 'no-cache',
                                    signal: abortController.signal
                                }).then((response) => {
                                    response.json().then((responseJson) => {
                                        renderGifs(responseJson, $klipyModal, trumbowyg, true);
                                    });
                                }).catch(function(error) {
                                    onError(error);
                                });
                            };
                            var throttledInputRequest = trumbowygThrottle(searchGifsOnInput, trumbowyg.o.plugins.klipy.throttleDelay);

                            $klipyInput.on('input', throttledInputRequest);
                            $klipyInput.focus();

                            $klipyClose.one('click', function () {
                                $klipyModal.trigger(CANCEL_EVENT);
                            });

                            var throttledQuery = trumbowygThrottle(function () {
                                if ($klipyModalScroll.scrollTop() + $klipyModalScroll.innerHeight() >= $klipyModalScroll[0].scrollHeight - 100) {
                                    if (nextCursor) {
                                        var query = $klipyInput.val();
                                        var url = query.length === 0 ? DEFAULT_URL : BASE_URL + '&q=' + encodeURIComponent(query);
                                        url += '&page=' + nextCursor;

                                        fetch(url, {
                                            method: 'GET',
                                            cache: 'no-cache',
                                            signal: abortController.signal
                                        }).then((response) => {
                                            response.json().then((responseJson) => {
                                                renderGifs(responseJson, $klipyModal, trumbowyg, false);
                                            });
                                        }).catch(function(error) {
                                            onError(error);
                                        });
                                    }
                                }
                            }, 500);

                            // Infinite scrolling
                            $klipyModalScroll.on('scroll', throttledQuery);
                        }
                    });
                }
            }
        }
    });
})(jQuery);
